import { useRef } from 'react';
import propertyManagements from '../assets/img/newimgaes/Property Instruction - India.jpeg'
import plumbing from '../assets/img/newimgaes/Tenant onboarding - India.jpeg'
import mortgage from '../assets/img/newimgaes/Mortgage.jpeg'
import electrical from '../assets/img/newimgaes/Tenant Checkin.jpeg'
import doorPic from '../assets/img/newimgaes/Full property management - India.jpeg'
import insurance from '../assets/img/newimgaes/Legal Documentation - India.jpeg'
import interior from '../assets/img/newimgaes/Marketing and Advertizing - India.jpeg'
import pLawers from '../assets/img/newimgaes/Periodic Inspections and Maintenance - India.jpeg'
import willManage from '../assets/img/newimgaes/Will management.jpeg';
import { Pageheader } from "./global-components/page-header";
import bgImage from '../assets/img/newimgaes/india-pmb.jpeg';
import { Button, Typography } from "@mui/material";
import { AddPropertyManagement } from './global-components/AddProperyManagement'

export const PropertyManagement = () => {
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });

    if (formRef.current && !('scrollBehavior' in document.documentElement.style)) {
      const elementPosition = formRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 100; // 100px offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const sections = [
    {
      title: "Property Instruction",
      imgSrc: propertyManagements,
      description: `Our comprehensive property instruction services include:
● Detailed property assessment and valuation
● Professional photography and floor plans
● Energy Performance Certificate (EPC) arrangement
● Property compliance checks
● Rental market analysis
● Setting competitive rental prices
● Property presentation advice`,
    },
    {
      title: "Marketing and Advertisements",
      imgSrc: interior,
      description: `We ensure maximum exposure for your property through:
● Premium listings on major property portals
● Professional property descriptions
● High-quality photography and virtual tours
● Social media marketing campaigns
● Email marketing to potential tenants
● Featured listings on our website
● Targeted local advertising`,
    },
    {
      title: "Tenant Screening & Onboarding",
      imgSrc: plumbing,
      description: `Our thorough tenant screening process includes:
● Background and credit checks
● Employment verification
● Previous landlord references
● Income verification
● Right to rent checks
● Guarantor arrangements if required
● Tenant interview and assessment`,
    },
    {
      title: "Tenant Check-in & Check-out",
      imgSrc: electrical,
      description: `We manage the entire moving process:
● Detailed inventory reports
● Property condition documentation
● Utility readings and transfers
● Key handover management
● Welcome pack provision
● Move-in inspection
● Final property inspection
● Deposit protection handling`,
    },
    {
      title: "Full Property Management",
      imgSrc: doorPic,
      description: `Our complete management service covers:
● Rent collection and processing
● Monthly financial reporting
● Maintenance coordination
● Emergency response handling
● Regular property inspections
● Tenant communication
● Compliance management
● Annual safety checks`,
    },
    {
      title: "Rental Assistance",
      imgSrc: mortgage,
      description: `We provide comprehensive rental support:
● Rent payment monitoring
● Arrears management
● Rent review services
● Deposit handling
● Rental agreement updates
● Tenant liaison
● Payment processing
● Financial reporting`,
    },
    {
      title: "Periodic Inspections and Maintenance",
      imgSrc: pLawers,
      description: `Regular property care services include:
● Scheduled property inspections
● Maintenance coordination
● Contractor management
● Emergency repairs
● Preventive maintenance
● Property updates and improvements
● Inspection reports
● Maintenance planning`,
    },
    {
      title: "Legal Documentation",
      imgSrc: insurance,
      description: `Complete legal support covering:
● Tenancy agreement preparation
● Section 21 and Section 8 notices
● Legal compliance updates
● License and permit management
● Safety certificates
● Insurance documentation
● Contract renewals
● Regulatory compliance`,
    },
    {
      title: 'Assistance in Buying and Selling',
      imgSrc: willManage,
      description: `Professional support for property transactions:
● Property valuation
● Market analysis
● Viewing arrangements
● Offer negotiation
● Transaction coordination
● Solicitor liaison
● Completion management
● Post-sale support`,
    }
  ];

  return (
    <>
      <Pageheader headertitle="Property Management" bgImage={bgImage} subTitle={'India'} />

      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <Typography fontSize={16}>
            Royale Spaces offer a comprehensive range of real estate management services in India, including
          </Typography>

          <Button
            onClick={scrollToForm}
            variant="contained"
            size='large'
            sx={{
              backgroundColor: '#d8b035',
              color: '#fff',
              fontWeight: '600',
              '&:hover': {
                backgroundColor: '#d8b035',
                transform: 'scale(1.05)',
                transition: 'all 0.3s ease',
              },
            }}
          >
            Register Now
          </Button>
        </div>

        <div className="row">
          {sections.map((section, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div className="service-section h-100" style={{
                border: '1px solid #eee',
                borderRadius: '8px',
                padding: '20px',
                backgroundColor: 'white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease',
              }}>
                <h3 style={{ fontSize: '1.5rem', marginBottom: '15px', color: '#10374A' }}>
                  {section.title}
                </h3>
                <div className="image-container" style={{
                  height: '200px',
                  overflow: 'hidden',
                  borderRadius: '5px',
                  marginBottom: '15px'
                }}>
                  <img
                    src={section.imgSrc}
                    alt={section.title}
                    className="img-fluid"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </div>
                <p style={{
                  whiteSpace: "pre-line",
                  fontSize: '14px',
                  lineHeight: '1.6',
                  color: '#666'
                }}>
                  {section.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Registration Form Section */}
        <div className="row mt-5" ref={formRef}>
          <div className="col-lg-12 col-md-10 mx-auto">
            <div style={{
              padding: '30px',
              borderRadius: '10px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              backgroundColor: 'white'
            }}>
              <AddPropertyManagement />
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        // .service-section:hover {
        //   transform: translateY(-5px);
        //   box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        // }
        // .service-section:hover img {
        //   transform: scale(1.05);
        // }
         html {
    scroll-behavior: smooth;
  }
        @media (max-width: 768px) {
          .col-md-6 {
            margin-bottom: 20px;
          }
        }
      `}</style>
    </>
  );
};